<template>
  <v-container
    fluid
    pa-0
  >
    <!-- Payment Form -->

    <!-- Complete Order -->
    <v-row>
      <v-col cols="12">
        <v-btn
          :disabled="disabled || loading"
          :large="$vuetify.breakpoint.xsOnly"
          :loading="loading"
          :x-large="$vuetify.breakpoint.smAndUp"
          block
          class="brand-green-dark--text pl-2 pr-3"
          color="brand-primary"
          depressed
          @click="completeOrder"
        >
          <v-badge
            v-if="cartProductsCount"
            bordered
            class="mr-2 order-badge"
            color="brand-beige-light"
            dark
            inline
          >
            <template #badge>
              <span class="brand-green-dark--text">{{ cartProductsCount }}</span>
            </template>
          </v-badge>

          <span class="brand-text-heading">{{ $t('Checkout.Button.CompleteOrder') }}</span>

          <v-spacer />

          <span class="ml-4 brand-text-heading">{{ orderTotal | currency }}</span>
        </v-btn>
      </v-col>
    </v-row>

    <otp-dialog
      v-if="otpModel"
      v-model="otpModel"
      :otp-error="otpError"
      :otp-progress="otpProgress"
      :visible.sync="otpDialogVisible"
      @validate="otpValidate"
    />
  </v-container>
</template>

<script>

import GenericPaymentGatewayMixin from '@/theme/default/components/payment/GenericPaymentGateway.js'

export default {
  name  : 'GenericPaymentGateway',
  mixins: [GenericPaymentGatewayMixin]
}
</script>

<style scoped src="@/theme/default/components/payment/GenericPaymentGateway.css"></style>

<style scoped>
/deep/ .order-badge .v-badge__badge {
  width: 22px;
  height: 22px;
  padding: 5px;
}
</style>
